module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_Foamcore.2092d1fd.jpg";